<template>
  <div id="footer" class="container-fluid">
    <div class="logo logobox">
      <img src="@/assets/img/logo2.png" alt="logo图" class="logo">
      <!-- <div class="tip">风道科技</div> -->
    </div>
    <div>
      <p class="title">深圳风道物联科技有限公司</p>
        <p class="address_tel_fax">
          <span>联系地址：深圳市龙岗区园山街道龙岗大道6277号</span>
          <span>Tel：13923711287</span>
          <!-- <span>Fax：8888-88888888</span> -->
        </p>
        <p class="email_wx">
          <span>联系邮箱：9311914@qq.com</span>
          <span>联系微信：13923711287</span>
        </p>

        <!-- <p class="title">{{fotterInfo2.company_name}}</p>
        <p class="address_tel_fax">
          <span>{{$t('message.Address')}}：{{fotterInfo2.address}}</span>
          <span>Tel：{{fotterInfo2.tel}}</span> -->
          <!-- <span>Fax：8888-88888888</span> -->
        <!-- </p> -->
        <!-- <p class="email_wx">
          <span>{{$t('message.email')}}：{{fotterInfo.e_mail}}</span>
          <span>{{$t('message.WeChat')}}：{{fotterInfo.wechat}}</span>
        </p> -->
        <a href="http://beian.miit.gov.cn" title="风道科技官网" target="_blank">
          <p class="copy">Copyright ©2023 粤ICP备2023054696号 深圳风道物联科技有限公司</p>
        </a>
    </div>
    <div >
      <div class="logobox">
        <img src="@/assets/img/bottom_wechat.jpg" alt="logo图" class="logo2">
      </div>
      <div class="tip">扫一扫添加微信</div>
    </div>

  </div>
</template>
<script>
import axios from 'axios'
import get from '../api/get'
export default {
  name: "Footer",
  data() {
    return {
      fotterInfo:{},
      logo:'',
      fotterInfo2:{},
      // url:'http://uat-www.fonedoor.com/'
      logo2:""
    };
  },
  created(){
    // console.log(this.url)
    // this.url ='http://uat-www.fonedoor.com/'
    // this.$i18n.locale = localStorage.localeLanguage || 'CN'
    // get('/api/configPublic',{
    //   lg:localStorage.localeLanguage
    // }).then((res)=>{
    //   console.log(res )
    //   if(res.data.code==200){
    //     this.fotterInfo=res.data.data.bottom
    //     this.fotterInfo2=res.data.data.bottom_jh
    //     this.logo = this.url+this.fotterInfo.logo+'?'+Math.round(Math.random() * 100000)
    //     this.logo2 = this.url+this.fotterInfo2.logo+'?'+Math.round(Math.random() * 100000)
    //     // this.logo2 = this.fotterInfo2.logo
    //     // this.info = res.data.data
    //     var data = JSON.stringify(res.data.data)
    //     sessionStorage.setItem('public',data)
    //   }else{
    //     alert('网络连接失败，请稍后重试')
    //   }
    // })
    // var Info = JSON.parse(sessionStorage.getItem('public'))
    // this.fotterInfo=Info.bottom
    // console.log(this.fotterInfo)
    // this.logo = this.url+this.fotterInfo.logo
    // console.log(this.logo)

  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background:#474747;
  overflow: hidden;
  /* text-align: center; */
  display: flex;
  justify-content: space-around;
  padding: 50px;
}
.logo {
  width: 200px;
  height: 200px;
  /* margin: 50px auto 20px; */
}
.logobox{
  padding: 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /* margin: 50px 0 10px; */
}
.logo2{
  width: 120px;
  height: 120px;
}
.box{
  display: flex;
  justify-content: center;
}
.box1{
  margin: 0 50px 20px;
  text-align: left;
}
.tip{
  text-align: center;
}
@media screen and (max-width: 997px) {
  #footer{
    text-align: center;
    display: block;
    justify-content: center;
    padding: 0;
  }
  .logobox{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 20px;
  }

  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
.box{
  display: block;
  /* justify-content: center; */
}
.box1{
  margin: 0;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue